import { InlineMessage } from "@repo/ui/inline-message";
import { InfoRound } from "@/theme/icons/info-round";
import { TYPOGRAPHY_BODY3_SENTENCE } from "@/theme/topshop/typography/typography-constants";

export const ChatErrorMessage = () => {
  return (
    <InlineMessage
      appearance="bordered"
      icon={<InfoRound />}
      inlineMessageClass={TYPOGRAPHY_BODY3_SENTENCE}
    >
      Oops! Something's gone wrong. Please check the following and try again:
      <br />
      You've only accepted third party cookies.
      <br />
      You only have one Topshop Help page window open.
      <br />
      You're not in incognito mode.
      <br />
    </InlineMessage>
  );
};
